export const ChangeRequestFileOperation = {
  ADDED: 'added',
  REMOVED: 'removed',
} as const;

export type ChangeRequestFileOperation =
  (typeof ChangeRequestFileOperation)[keyof typeof ChangeRequestFileOperation];
